<template>
  <el-container>
    <el-header v-if="isShow" style="padding: 0;">
      <router-view name="vheader"></router-view>
    </el-header>
    <el-main style="overflow: initial;">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CryptoJS from 'crypto-js'
export default {
  name: 'home',
  data() {
    return {
      isShow: true
    }
  },
  created() {
    let wanhs = this.$route.query.whs
    if (wanhs) {
      this.isShow = false
    } else {

      if (!this.menus || this.menus.length == 0) {
        //解密menus
        let menus = localStorage.getItem('menus')
        const secretKey = 'i7T4MtYsiT0i9zB4iaQrFs3rTzx0BhF5'
        try {
          const newMenus = CryptoJS.AES.decrypt(menus, secretKey).toString(CryptoJS.enc.Utf8)

          // sessionStorage.getItem('menus')
          if (newMenus && newMenus.length > 0) {
            this.setLogin(JSON.parse(newMenus))
          } else {
            this.clearSession()
          }
        } catch (e) {
          if (this.$route.path !== '/' && this.$route.path !== '/login') {
            this.$router.push({
              path: '/login'
            });
          }
        }
      }
    }
  },
  destroyed() {
    this.clearSession()
  },
  computed: {
    ...mapState(['menus']),
  },
  methods: {
    ...mapMutations(['setLogin']),
    clearSession() {
      localStorage.removeItem('token')
      localStorage.removeItem('menus')
      if (this.$route.path !== '/' && this.$route.path !== '/login') {
        this.$router.push({
          path: '/login'
        });
      }
    }
  }
}
</script>
<style scoped>
.well-lg {
  padding: 1em 0;
  background: rgb(84, 92, 100);
  line-height: 2em;
  text-align: center;
  color: #c8c9ca;
  letter-spacing: 2px;
}
</style>
